import { SampleType } from '@resistapp/common/sampling-point-types';
import { FullSample, Process } from '@resistapp/common/types';
import { keyBy } from 'lodash';

export function shouldEnableProcessGroupLevel(processes: Process[] | undefined, supportedSamples: FullSample[] | undefined): boolean {
  if (!processes?.length || !supportedSamples?.length) {
    return false;
  }

  const samplingPointById: Record<number, FullSample['samplingPoint'] | undefined> = keyBy(
    supportedSamples.map(sample => sample.samplingPoint),
    samplingPoint => samplingPoint.id,
  );

  return processes.some(process => {
    const stepIds = process.samplingPointIds ?? [];
    const hasFoodStep = stepIds.some(stepId => samplingPointById[stepId]?.type === SampleType.FOOD);
    return stepIds.length > 2 || hasFoodStep;
  });
}
